module.exports = __webpack_public_path__ + "img/avatar.357522df.png";